import React from 'react';

import BattlePlanSelector from '@/components/BattlePlanSelector';

export default function TellingIndex() {
  return (
    <BattlePlanSelector 
      routeType="telling" 
      title="Telling Plans"
      battlePlanTypeFilter="gotv-telling"
    />
  );
} 